import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=795d6fd5&scoped=true&"
import script from "./SearchModal.vue?vue&type=script&lang=ts&"
export * from "./SearchModal.vue?vue&type=script&lang=ts&"
import style0 from "./SearchModal.vue?vue&type=style&index=0&id=795d6fd5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795d6fd5",
  null
  
)

export default component.exports